import { RouteRecordRaw } from 'vue-router';

const LoginMethodsPage = () => import('@/_redesign/modules/Profile/pages/LoginMethodsPage.vue');
const ProfileMain = () => import('@/_redesign/modules/Profile/pages/ProfileMain.vue');
const InfoPage = () => import('@/_redesign/modules/Profile/pages/InfoPage.vue');
const StatementsPage = () => import('@/_redesign/modules/Profile/pages/StatementsPage.vue');

export const USER_SETTINGS_CHILDREN: RouteRecordRaw[] = [
  {
    path: '',
    name: 'user-dashboard-settings-main',
    component: ProfileMain,
  },
  {
    path: 'info',
    name: 'user-dashboard-settings-info',
    component: InfoPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'user-dashboard-settings-main',
        },
      },
    },
  },
  {
    path: 'statements',
    name: 'user-dashboard-settings-statements',
    component: StatementsPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'user-dashboard-settings-main',
        },
      },
    },
  },
  {
    path: 'login-methods',
    name: 'user-dashboard-settings-login-methods',
    component: LoginMethodsPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'user-dashboard-settings-main',
        },
      },
    },
  },
];

export const MERCHANT_SETTINGS_CHILDREN: RouteRecordRaw[] = [
  {
    path: '',
    name: 'merchant-dashboard-settings-main',
    component: ProfileMain,
  },
  {
    path: 'info',
    name: 'merchant-dashboard-settings-info',
    component: InfoPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'merchant-dashboard-settings-main',
        },
      },
    },
  },
  {
    path: 'statements',
    name: 'merchant-dashboard-settings-statements',
    component: StatementsPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'merchant-dashboard-settings-main',
        },
      },
    },
  },
  {
    path: 'login-methods',
    name: 'merchant-dashboard-settings-login-methods',
    component: LoginMethodsPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          isBackVisible: true,
          backName: 'merchant-dashboard-settings-main',
        },
      },
    },
  },
];
